import { Link } from 'react-router-dom';

const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-global-line',
      title: 'Website & Social Media Account Creation',
      description: 'Launch your digital presence with professionally designed websites and optimized social media profiles across all major platforms.',
      gradient: 'from-[#FF6B35]/20 to-[#FF6B35]/5',
      color: '#FF6B35',
    },
    {
      icon: 'ri-search-line',
      title: 'Website SEO Management',
      description: 'Boost your online visibility with comprehensive SEO strategies that drive organic traffic and improve search engine rankings.',
      gradient: 'from-[#00D9FF]/20 to-[#00D9FF]/5',
      color: '#00D9FF',
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Social Media Account Management',
      description: 'Grow your brand presence with strategic content creation, community engagement, and consistent posting across all platforms.',
      gradient: 'from-[#10B981]/20 to-[#10B981]/5',
      color: '#10B981',
    },
    {
      icon: 'ri-advertisement-line',
      title: 'Meta & Google Ads',
      description: 'Maximize your ROI with expertly managed advertising campaigns on Meta (Facebook & Instagram) and Google platforms.',
      gradient: 'from-[#F59E0B]/20 to-[#F59E0B]/5',
      color: '#F59E0B',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Consultancy',
      description: 'Strategic business guidance to optimize operations, drive growth, and achieve your organizational goals with expert insights.',
      gradient: 'from-[#8B5CF6]/20 to-[#8B5CF6]/5',
      color: '#8B5CF6',
    },
    {
      icon: 'ri-building-line',
      title: 'B2B Marketing',
      description: 'Specialized marketing strategies for business-to-business relationships, lead generation, and enterprise-level growth solutions.',
      gradient: 'from-[#EC4899]/20 to-[#EC4899]/5',
      color: '#EC4899',
    },
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="mb-20">
          <div className="text-accent text-sm font-semibold tracking-wider uppercase mb-4">
            /WHAT WE DO
          </div>
          <h2 className="text-6xl font-bold text-dark text-center">
            Services That Drive{' '}
            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
              Results
            </span>
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group relative bg-gradient-to-br ${service.gradient} rounded-3xl p-8 hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 ${service.span || ''}`}
              style={{ backgroundColor: '#1A1F3A' }}
            >
              {/* 3D Icon */}
              <div className="relative mb-6">
                <div 
                  className="w-20 h-20 rounded-2xl flex items-center justify-center transform group-hover:scale-110 group-hover:-translate-y-2 transition-all duration-500"
                  style={{ 
                    backgroundColor: service.color,
                    boxShadow: `0 20px 40px ${service.color}40`
                  }}
                >
                  <i className={`${service.icon} text-4xl text-white`}></i>
                </div>
              </div>

              {/* Content */}
              <h3 className="text-3xl font-bold text-white mb-4">
                {service.title}
              </h3>
              <p className="text-gray-400 text-base leading-relaxed mb-6">
                {service.description}
              </p>

              {/* Learn More Link */}
              <Link
                to="/services"
                className="inline-flex items-center gap-2 font-semibold transition-all group-hover:gap-4"
                style={{ color: service.color }}
              >
                Learn More
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;
